import React, {PropTypes} from 'react';
import {connect} from 'react-redux';


// import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({});

class EducationDiamond extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);
		this.state = {}
	}

	componentDidMount() {
    document.title = 'Diamonds Direct - Education';
    document.getElementsByTagName("META")[7].content="Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
  }

  newTabNav(page) {
  	let win = window.open(page, '_blank');
    win.focus();
  }

  externalNav(page) {
    window.location.href = '/' + page;
  }

  internalNav(page) {
  	this.context.router.push('/' + page);
  }

  openIntercom() {
    acquireIO.max();
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

	render() {
		return <div className={'EducationDiamond EducationPage'}>
      <div className='eduHeader'>Diamond Education</div>
      <div className='eduBody'>
        <div className='edHeader'>
          <div className='edhTitle'>
            <img src='https://ddw2.diamondsdirect.com/img/education/diamond/4cs.svg' />
          </div>
          <div className='edBr'></div>
          <div className='edHeaderText'>
            <div className='edhTextWrapper'>Selecting the perfect diamond starts with a little education. We begin with the 4 C’s: Carat, Cut, Color, and Clarity.</div>
          </div>
        </div>
        <div className='shopDiamondsWrapper'>
          <span className='ttLink' onClick={() => this.internalNav('gallery/engagement-rings?mode=diamond')}>Shop Diamonds &gt;</span>
        </div>
        <div className={'fourSection desktopOnly'}>
          <img src='https://ddw2.diamondsdirect.com/img/education/diamond/desktop/4cs.jpg' />
        </div>
        <div className={'fourSection mobileOnly'}>
          <div className='fsMobTopImage'>
            <img src='https://ddw2.diamondsdirect.com/img/education/diamond/mobile/4csbanner_m.jpg' />
          </div>
          <div className={'fsMobInfoElement fsElem1'}>
            <img src='https://ddw2.diamondsdirect.com/img/education/diamond/mobile/cut_m.png' />
          </div>
          <div className={'fsMobInfoElement fsElem2'}>
            <img src='https://ddw2.diamondsdirect.com/img/education/diamond/mobile/carat_m.png' />
          </div>
          <div className='fsMobMidImage'>
            <img src='https://ddw2.diamondsdirect.com/img/education/diamond/mobile/4cs2_m.jpg' />
          </div>
          <div className={'fsMobInfoElement fsElem3'}>
            <img src='https://ddw2.diamondsdirect.com/img/education/diamond/mobile/clarity_m.png' />
          </div>
          <div className={'fsMobInfoElement fsElem4'}>
            <img src='https://ddw2.diamondsdirect.com/img/education/diamond/mobile/color_m.png' />
          </div>
        </div>
        <div className='gradingSection'>
          <div className='gradingDiamonds'>
            <img className='desktopOnly' src='https://ddw2.diamondsdirect.com/img/education/diamond/desktop/loosediamonds.png' />
            <img className='mobileOnly' src='https://ddw2.diamondsdirect.com/img/education/diamond/mobile/loosediamonds_m.png' />
          </div>
          <div className='gradingTitle'>Additional Diamond Grading Criteria</div>
          <div className='gradingWrapper'>
            <div className='gradingItem'>
              <div className='giImg'>
                <img src='https://ddw2.diamondsdirect.com/img/education/diamond/polish.svg' />
              </div>
              <div className='giLabel'>POLISH</div>
              <div className='giText'>Grading for polish quality refers to the overall craftsmanship of the finished diamond. Are the edges sharp? Are the facets smooth and flat? Polishing wheel marks should not be visible without magnification.</div>
            </div>
            <div className='gradingItem'>
              <div className='giImg'>
                <img src='https://ddw2.diamondsdirect.com/img/education/diamond/symmetry.svg' />
              </div>
              <div className='giLabel'>SYMMETRY</div>
              <div className='giText'>Symmetrical diamonds reflect more light, adding to the overall sparkle. Gemologists review more than 20 different symmetry features in order to grade how perfectly the facets and cut angles align.</div>
            </div>
            <div className='gradingItem'>
              <div className='giImg'>
                <img src='https://ddw2.diamondsdirect.com/img/education/diamond/flourescence.svg' />
              </div>
              <div className='giLabel'>FLUORESCENCE</div>
              <div className='giText'>Fluorescence measures the color of the light emitted by a diamond under an ultraviolet light. While diamond professionals often prefer a fluorescence grade of “none”, “Faint” or “Medium” grades will offer a better value in lower diamond colors.</div>
            </div>
          </div>
        </div>
        <div className='measurementSection'>
          <div className='msTitle'>MEASUREMENTS & PROPORTIONS</div>
          <div className='msCopy'>The diamond measurement and proportions define a diamond’s overall visual appeal. Some diamonds are cut to emphasize the total carat weight, while others are designed to enhance brilliance and luster. Gemologists use these measures to precisely measure each diamond’s unique personality.</div>
          <div className='msBody'>
            <img className='desktopOnly' src='https://ddw2.diamondsdirect.com/img/education/diamond/desktop/measurements.jpg' />
            <img className='mobileOnly' src='https://ddw2.diamondsdirect.com/img/education/diamond/mobile/measurements_m.jpg' />
          </div>
        </div>
        <div className='certSection'>
          <div className='csInnerWrapper'>
            <div className='csImage'></div>
            <div className='csText'>
              <div className='cstTitle'>CERTIFIED DIAMONDS</div>
              <div className='cstBody'>A certification is an independent quality report on a specific diamond. It is issued by a diamond grading laboratory with no affiliation to any retail outlet, giving the con- sumer a completely objective opinion on the diamond’s quality. The certification in- cludes the exact measurements, proportions, color grade, clarity grade, cut grade and carat weight of the diamond. It also includes specifics that most jewelers do not have the equipment or the knowledge to determine, such as the diamond’s fluores- cence, polish, and symmetry. Each certification has its own number, the date which it was analyzed, and a plot chart which shows the internal and external characteristics of the diamond. The leading diamond laboratory in the world and the one that is setting the diamond grading standard is the Gemological Institute of America (G.I.A.).</div>
            </div>
          </div>
        </div>
      </div>
		</div>;
	}
}
export default EducationDiamond;

function mapStateToProps(state) {
  return {

  };
}

export const EducationDiamondContainer = connect(
  mapStateToProps,
  allActionCreators
)(EducationDiamond);


// WEBPACK FOOTER //
// ./src/components/views/education/EducationDiamond.jsx